var _path;
import * as React from "react";
function SvgEllipsisVertical(props) {
  return /*#__PURE__*/React.createElement("svg", props, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38 20a4.154 4.154 0 11-8.308 0A4.154 4.154 0 0138 20zm-13.846 0a4.154 4.154 0 11-8.309 0 4.154 4.154 0 018.309 0zm-18 4.154a4.154 4.154 0 110-8.309 4.154 4.154 0 010 8.309z"
  })));
}
export default SvgEllipsisVertical;